module.exports = __webpack_public_path__ + "img/1.a13e1056.png";